<template>
    <div>
        <base-header class="mt-4 pb-6" type=""></base-header>
        <b-container fluid class="mt--6">
            <div>
                <loading :active="loadingCounter > 0" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="fullPage">
                </loading>
            </div>
            <b-row>
                <b-col lg="12">
                    <div class="card-wrapper">
                        <card>
                            <div slot="header" class="mb-0">
                                <b-row>
                                    <b-col cols="12">
                                    <h3>Customer Outstanding Invoices</h3>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col md="12" >
                                    <base-input :label="language_terms['CUSTOMER']">
                                        <multiselect
                                            :internalSearch = "false"
                                            v-model="selectedCustomer"
                                            ref="multiselcetRef"
                                            label="name"
                                            track-by="id"
                                            placeholder="Type to search"
                                            open-direction="bottom"
                                            :preserve-search="false"
                                            :options="customers"
                                            :multiple="false"
                                            :searchable="true"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :options-limit="300"
                                            :limit="50"
                                            :limit-text="limitText"
                                            :max-height="600"
                                            :show-no-results="false"
                                            :hide-selected="false"
                                            @search-change="asyncFindCustomer"
                                            @input="onSelectCustomer"
                                            id="lookupId"
                                        >
                                        </multiselect>
                                    </base-input>
                                </b-col>
                            </b-row>
                            <b-row v-if="customerDetails != null">
                                <b-col md="3" >
                                    <base-input :label="language_terms['ATTENTION']" :value="customerDetails.header.contact_person" disabled></base-input>
                                </b-col>
                                <b-col md="3" >
                                    <base-input :label="language_terms['TELEPHONE']" :value="customerDetails.header.contact_telephone" disabled></base-input>
                                </b-col>
                                <b-col md="3" >
                                    <base-input :label="language_terms['FAX']" :value="customerDetails.header.contact_fax" disabled></base-input>
                                </b-col>
                                <b-col md="3" >
                                    <base-input :label="language_terms['EMAIL']" :value="customerDetails.header.contact_email" disabled></base-input>
                                </b-col>
                                <b-col md="3" >
                                    <base-input :label="language_terms['OUTSTANDING_AMOUNT']" :value="customerDetails.header.os_amount" disabled></base-input>
                                </b-col>
                                <b-col md="3" >
                                    <base-input :label="language_terms['OVERDUE_AMOUNT']" :value="customerDetails.header.overdue_amount" disabled></base-input>
                                </b-col>
                                <b-col md="3" >
                                    <base-input :label="language_terms['AVAILABLE_CREDIT_LIMIT']" :value="(customerDetails.header.customer_credit_limit_available * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                                </b-col>
                                <b-col md="3" >
                                    <base-input :label="language_terms['CREDIT_LIMIT']" :value="(customerDetails.header.customer_credit_limit * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                                </b-col>
                                <b-col md="6" >
                                    <base-input :label="language_terms['CREDIT_TERMS']" :value="customerDetails.header.customer_credit_term" disabled></base-input>
                                </b-col>
                                <b-col md="6">
                                    <base-input :label="language_terms['VIEW']">
                                        <el-select v-model="views" filterable>
                                            <el-option v-for="option in views_options"
                                                        :key="option.value"
                                                        :label="option.label"
                                                        :value="option.value">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                            </b-row>

                            <!-- OS Invoices -->
                            <b-row v-if="customerDetails != null && customerDetails.details.length > 0 && views != 'RECEIPTS'" class="mt-4">
                                <b-col cols="12">
                                    <h3>Outstanding Invoice List</h3>
                                </b-col>
                                <b-col cols="12">
                                    <v-client-table v-if="customerDetails.details.length > 0" v-model="customerDetails.details" :columns="tableColumns" :options="reportOptions" @row-click="onClickInvoice" >
                                    </v-client-table>
                                </b-col>
                            </b-row>
                            <!-- Receipts -->
                            <b-row v-if="customerDetails != null && customerDetails.receipt_details.length > 0 && views == 'RECEIPTS'" class="mt-4">
                                <b-col cols="12">
                                    <h3>Receipts Entries List</h3>
                                </b-col>
                                <b-col cols="12">
                                    <v-client-table v-if="customerDetails.receipt_details.length > 0" v-model="customerDetails.receipt_details" :columns="receipts_tableColumns" :options="reportOptions" @row-click="onClickReceipt" >
                                    </v-client-table>
                                </b-col>
                            </b-row>
                        </card>
                    </div>
                </b-col>
            </b-row>
            <!-- Pop up modal Invoice-->
            <b-modal id="modalInvoice" v-model="modalInvoice" size="xl" centered class="my-modal" hide-footer>
                <template>
                    <div v-if="modalInvoice">
                        <b-row class="align-items-center mt--2">
                            <b-col md="12" fluid class="mt--7">
                                <h6 class="h2">{{language_terms["INVOICE"]}}</h6>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="3" md="6">
                                <base-input :label="language_terms['INV_#']" :value="invoice.master.code" disabled></base-input>
                            </b-col>
                            <b-col lg="3" md="6">
                                <base-input :label="language_terms['DATE']" :value="invoice.master.date" disabled></base-input>
                            </b-col>
                            <b-col lg="3" md="6">
                                <base-input :label="language_terms['SALESPERSON']" :value="invoice.master.salesperson_name" disabled></base-input>
                            </b-col>
                            <b-col lg="3" md="6">
                                <base-input :label="language_terms['TYPE']" :value="invoice.master.type" disabled></base-input>
                            </b-col>
                            <b-col lg="12">
                                <base-input label="Remarks"><textarea disabled class="form-control" id="exampleFormControlTextarea1" rows="3" :value="invoice.master.remarks"></textarea>
                                </base-input>
                            </b-col>
                        </b-row>
                        <b-row v-if="invoice.details.rows.length > 0">
                            <b-col cols="12">
                                <v-client-table v-model="invoice.details.rows" :columns="invoice.details.columns" :options="reportOptions"  >
                                </v-client-table>
                            </b-col>
                        </b-row>
                    </div>
                </template>
            </b-modal>

            <!-- Pop up modal Receipt-->
            <b-modal id="modalReceipt" v-model="modalReceipt" size="xl" centered class="my-modal" hide-footer>
                <template>
                    <div>
                        <b-row class="align-items-center">
                            <b-col md="12" fluid class="mt--6">
                                <h6 class="h2">{{language_terms["RECEIPT_DETAILS"]}}</h6>
                            </b-col>
                        </b-row>
                        <b-row >
                            <b-col cols="12">
                                <v-client-table v-model="receipt.rows" :columns="receipt.columns" :options="reportOptions"></v-client-table>
                            </b-col>
                        </b-row>
                    </div>
                </template>
            </b-modal>
        </b-container>
    </div>
</template>

<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>
  
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>

<script>
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue';
import BaseInput from '../../components/Inputs/BaseInput.vue';
import { event } from 'd3';

export default 
{
    components:
    {
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        PaginatedTables
    },

    computed:
    {
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
        }),
    },

    async mounted()
    {
        this.loadingCounter++


        this.loadingCounter--
    },

    data()
    {
        return{
        loadingCounter:0, 
        reportOptions:{perPage:100, perPageValues:[],stickyHeader:false, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:[],filterable:false},
        modalInvoice:false,
        modalReceipt:false,
        customers:[],
        invoice:null,
        receipt:{columns:[], rows:[]},
        customerDetails:null,
        selectedCustomer:null,
        fullPage:true,
        loading:false,
        tableItems:[],
        tableColumns: ["date","Inv #","type", "currency", "Inv OS Amount", "Ex Rate", "OS Amount (SGD)", "Accumulated Balance (SGD)", "status"],
        receipts_tableColumns: ["date","receipts #", "currency", "amount", "in home amount"],
        views:'Invoices',
        views_options:[
          {
            label:"Invoices",
            value:"INVOICES"
          },
          {
            label:"Receipts",
            value:"RECEIPTS"
          },
        ],
        }
    },

    methods:
    {
        async onClickReceipt(event)
        {
            if (event.row)
            {
                let payload = {receipt_id:event.row.id}
                await axios.post(apiRoutes['CLIENT_SALES_RECEIPT_ENTRY_RETRIEVE'],payload, authHeader()).then((response)=>
                {
                    if (response.data.code == 1)
                    {
                        this.receipt = response.data.data
                        this.modalReceipt = true
                    }
                    else
                    {
                        this.receipt = null;
                    }
                }
                )
                .catch((error)=> {
                    if(error.response)
                    {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    }
                });
            }
        },
        async onClickInvoice(event)
        {
            if (event.row)
            {
                let payload = {document_id:event.row.id}
                await axios.post(apiRoutes['CLIENT_RETRIEVE_SALES_INVOICE'],payload, authHeader()).then((response)=>
                {
                    if (response.data.code == 1)
                    {
                        this.invoice = response.data.data
                        this.modalInvoice = true
                    }
                    else
                    {
                        this.invoice = null;
                    }
                }
                )
                .catch((error)=> {
                    if(error.response)
                    {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    }
                });
            }
        },
        limitText(count)
        {
            return `and ${count} other customers`;
        },
        async onSelectCustomer(selectedOption)
        {
            this.loadingCounter ++

            if (selectedOption)
            {
                this.views = 'Invoices'
                let payload = {"customer_id":selectedOption.id}
                await axios.post(apiRoutes["CLIENT_RETRIEVE_CUSTOMER_OS_INVOICES"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.customerDetails = response.data.data;
                } else {
                    this.customerDetails = [];
                }

                })
                .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
                }
                });
            }

            this.loadingCounter --

        },
        async asyncFindCustomer(query) 
        {
            let payload = { value: query };
            await axios.post(apiRoutes["CUSTOMER_LOOKUP"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.customers = response.data.data;
                } else {
                    //this.customers = [];
                }
                })
                .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
                }
            });
        },
    }
}
</script>
